import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { MapPinIcon } from 'lucide-react';
const VENUE_IMAGES = [{
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-1.jpg',
  alt: 'Fortbildungszentrum Seminarraum',
  span: 'col-span-1 row-span-2'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-2.jpg',
  alt: 'Kursraum Ausstattung',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-3.jpg',
  alt: 'Behandlungsplätze',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-4.jpg',
  alt: 'Hands-on Arbeitsbereich',
  span: 'col-span-1 row-span-2'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-5.jpg',
  alt: 'Praxisnahe Übungsplätze',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-6.jpg',
  alt: 'Moderne Technik',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-7.jpg',
  alt: 'Empfangsbereich',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-8.jpg',
  alt: 'Pausenbereich',
  span: 'col-span-1 row-span-2'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-9.jpg',
  alt: 'Fortbildungsraum Detail',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-10.jpg',
  alt: 'Kursraum Übersicht',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-11.jpg',
  alt: 'Arbeitsplätze Detail',
  span: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.rawproductionsgmbh.de/2n/raum/raum-12.jpg',
  alt: 'Gebäude Außenansicht',
  span: 'col-span-1 row-span-1'
}];
export function VenueGallery() {
  return <section className="py-16 md:py-24 bg-[#1a1a1a] relative overflow-hidden" data-id="element-702">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-703">
        <div className="absolute -top-40 -left-40 w-[30rem] h-[30rem] bg-[#3b7780] rounded-full mix-blend-screen filter blur-[120px] opacity-15" data-id="element-704"></div>
        <div className="absolute -bottom-40 -right-40 w-[30rem] h-[30rem] bg-[#59d0d4] rounded-full mix-blend-screen filter blur-[120px] opacity-10" data-id="element-705"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-706">
        <ScrollReveal variant="up" data-id="element-707">
          <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-708">
            <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-709">
              Fortbildungszentrum Nürnberg
            </span>
            <h2 className="text-2xl md:text-5xl font-extrabold text-white mb-6 tracking-tight" data-id="element-710">
              Unsere Räumlichkeiten
            </h2>
            <p className="text-base sm:text-lg text-[#748282] font-medium leading-relaxed" data-id="element-711">
              Modernste Ausstattung für Ihre Fortbildung – von voll
              ausgestatteten Behandlungsplätzen bis hin zu komfortablen
              Seminarräumen. Lernen Sie in einer Umgebung, die Praxisnähe und
              Professionalität vereint.
            </p>
            <div className="flex items-center justify-center gap-2 mt-6 text-slate-400" data-id="element-712">
              <MapPinIcon className="w-4 h-4 text-[#59d0d4]" data-id="element-713" />
              <span className="text-sm font-bold" data-id="element-714">
                Ludwigsplatz 1a, 90403 Nürnberg
              </span>
            </div>
          </div>
        </ScrollReveal>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[200px] gap-3 md:gap-4" data-id="element-715">
          {VENUE_IMAGES.map((image, idx) => <ScrollReveal key={idx} variant="scale" delay={idx * 60} className={image.span} data-id="element-716">
              <div className="w-full h-full rounded-2xl overflow-hidden group relative" data-id="element-717">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-718" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-719"></div>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}